<template>
  <v-dialog v-model="visible" persistent :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-layout v-for="col in getDialogKeys" :key="col.value">
          <v-flex>
            <v-textarea
              v-if="col.value === 'products'"
              :label="col.text"
              v-model="itemDetail[col.value]"
            />
            <v-text-field
              v-else
              v-model="itemDetail[col.value]"
              :label="col.text"
              :color="Theme.GREEN"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent"
          >取消</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          dark
          :color="Theme.GREEN"
          :loading="saveLoading"
          @click="confirmEvent"
          >確定</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";

export default {
  name: "watsonsDetail",
  mixins: [common],
  props: {
    title: String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      saveLoading: false,
    };
  },
  created() {},
  computed: {
    getDialogKeys() {
      return [
        { value: "orderId", text: "訂單編號" },
        { value: "orderDate", text: "訂單日期" },
        { value: "shippingNumber", text: "物流單號" },
        { value: "payType", text: "付款方式" },
        { value: "shopNo", text: "取貨店號" },
        { value: "shopName", text: "取貨門市名稱" },
        { value: "customName", text: "收件人姓名" },
        { value: "phone", text: "電話" },
        { value: "price", text: "總金額" },
      ];
    },
  },
  methods: {
    ...mapActions(["watsonsSave"]),
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    async confirmEvent() {
      this.saveLoading = true;

      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.watsonsSave({
        token: "",
        info: this.itemDetail,
      });
      const result = res.data;
      if (result.code === 0) {
        this.$emit("confirmEvent", this.itemDetail);
      } else {
        this.showMessageDialog(
          "錯誤",
          result.message ? result.message : "儲存失敗"
        );
      }
      this.saveLoading = false;
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        confirmEvent: async () => {
          this.hideAlert();
        },
      });
    },
  },
};
</script>

<style scoped>
</style>
